export default "__VITE_ASSET__AtZByDCP__"